import { atom, useAtom } from 'jotai';
import {
  RushGameStatus,
  Prize,
  RewardRecord,
  RushBetItem,
  OnlineUserRushBet,
} from './types';
import { atomWithImmer } from 'jotai-immer';
import { RushPlayer } from '@/components/features/casino/rush/RushPlayerBox/useRushPlayer';

export const moonRushInfo = atomWithImmer({
  gameId: '',
  gameRoundId: '',
  gameStatus: RushGameStatus.INIT,
  countdown: 0,
  timer: 15 * 60 * 1000,
  nextRoundIn: 10000,
  totalGamePoint: '0',
  currentGamePoint: '0',
  currentUserPoint: '0',
  poolAmount: '0',
  rushPoint: '0',
  grandPrizeAmount: '0',
  majorPrizeAmount: '0',
  miniPrizeAmount: '0',
  winner: null,
  trigger: null,
});
export const inRushStageAtom = atom(
  (get) => get(moonRushInfo).gameStatus === RushGameStatus.RUSH,
);
export const rushGrandPrizeProgress = atom((get) => {
  const { currentGamePoint, rushPoint, gameStatus } = get(moonRushInfo);
  if (gameStatus !== RushGameStatus.RUSH) return 0;
  if (Number(currentGamePoint) === 0) return 0;
  return (Number(currentGamePoint) / Number(rushPoint)) * 100;
});

export const rushBetAmountAtom = atomWithImmer(0.2);
/**
 * init user point
 * update user point
 * clear user point
 */
export const currentUserPointAtom = atomWithImmer(0);
export const userWinRateAtom = atom((get) => {
  const { totalGamePoint } = get(moonRushInfo);
  const userPoint = get(currentUserPointAtom);
  const total = Number(totalGamePoint);
  if (total === 0) {
    return 0;
  } else {
    const rate = (100 * userPoint) / total;
    return Math.min(100, Math.floor(rate));
  }
});
//bet map
export const rushBetMapAtom = atomWithImmer<Record<string, RushBetItem>>({});
export const rushBetAmountListAtom = atomWithImmer([
  '0.2',
  '0.4',
  '0.6',
  '0.8',
  '1',
  '2',
  '5',
  '6',
  '8',
  '12',
  '14',
  '18',
  '24',
  '30',
  '50',
]);
export const isAnimatingState = atom(false);

export const resultPrizeState = atom<Prize | -1>(-1);

export const timerRewardAtom = atom<string>('');

export const currentPlayerTurnRewards = atom<Prize[]>([]);

export const userBetsRecordState = atom<RewardRecord[]>([]);

export const rushPlayerListState = atom<RushPlayer[]>([]);

export const LuckyPotSizeAtom = atom<{
  isMobile: boolean;
  isTablet: boolean;
  isDesktop: boolean;
}>({
  isMobile: false,
  isTablet: false,
  isDesktop: false,
});
